import { render, staticRenderFns } from "./downloadRecord.vue?vue&type=template&id=80efb828&scoped=true&"
import script from "./downloadRecord.vue?vue&type=script&lang=js&"
export * from "./downloadRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80efb828",
  null
  
)

export default component.exports